import {
  ChangeDetectorRef,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  matDialogSlideInLeftOptions,
  matDialogSlideInRightOptions,
} from '../../material-configs';

@Component({
  selector: 'am-layout-responsive',
  templateUrl: './layout-responsive.component.html',
  styleUrls: ['./layout-responsive.component.scss'],
})
export class LayoutResponsiveComponent {
  constructor(public dialog: MatDialog, public cd: ChangeDetectorRef) {}

  @Input() leftContent: TemplateRef<any>;
  @Input() rightContent: TemplateRef<any>;

  dialogLeft: MatDialogRef<TemplateRef<any>>;
  dialogRight: MatDialogRef<TemplateRef<any>>;

  openLeft() {
    this.dialogLeft = this.dialog.open(this.leftContent, {
      ...matDialogSlideInLeftOptions,
      // width: this.asideLeftWidth,
      panelClass: [].concat(matDialogSlideInLeftOptions.panelClass),
      // .concat(this.asideLeftDialogPanelClass),
      closeOnNavigation: true,
    });
    this.dialogLeft.afterClosed().subscribe(() => {
      this.dialogLeft = null;
    });
  }

  openRight() {
    this.dialogRight = this.dialog.open(this.rightContent, {
      ...matDialogSlideInRightOptions,
      // width: this.asideRightWidth,
      panelClass: [].concat(matDialogSlideInRightOptions.panelClass),
      // .concat(this.asideRightDialogPanelClass),
      closeOnNavigation: true,
    });
    this.dialogRight.afterClosed().subscribe(() => {
      this.dialogRight = null;
    });
  }
}
